var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M5.31536 0.707105L0.729568 5.29289C0.0996031 5.92286 0.54577 7 1.43667 7H6.02246C6.57475 7 7.02246 6.55228 7.02246 6V1.41421C7.02246 0.523309 5.94532 0.0771403 5.31536 0.707105Z",
    fill: "#0051BA",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputIcon);
export default __webpack_public_path__ + "static/media/input-icon.9de28c74adb01b86c4ec660be4dcba8f.svg";
export { ForwardRef as ReactComponent };